import script from "./colorCombinMngPop.vue?vue&type=script&setup=true&name=colorCombinMngPop&lang=js"
export * from "./colorCombinMngPop.vue?vue&type=script&setup=true&name=colorCombinMngPop&lang=js"

const __exports__ = script;

export default __exports__